import { render, staticRenderFns } from "./DelDialog.vue?vue&type=template&id=11c5d7e3&scoped=true&"
import script from "./DelDialog.vue?vue&type=script&lang=js&"
export * from "./DelDialog.vue?vue&type=script&lang=js&"
import style0 from "./DelDialog.vue?vue&type=style&index=0&id=11c5d7e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c5d7e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11c5d7e3')) {
      api.createRecord('11c5d7e3', component.options)
    } else {
      api.reload('11c5d7e3', component.options)
    }
    module.hot.accept("./DelDialog.vue?vue&type=template&id=11c5d7e3&scoped=true&", function () {
      api.rerender('11c5d7e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/DelDialog.vue"
export default component.exports